import React, { useEffect, useState } from "react";
import { Spin, Table, Tag, Typography } from "antd";
import { AlertCircle } from 'react-feather';
import { getDaysInMonth, getNumberSuffix } from "../../../utils/date";
import {
  getAttendanceFilterBy,
  getAttendanceFilterByModule,
  getAttendanceFilterByMonth,
} from "../../../firebase/utils";

const { Text } = Typography;
const initialColumn = [
  {
    title: "Student Id",
    dataIndex: "studentId",
    key: "studentId",
    fixed: "left",
    width: 100,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    fixed: "left",
    width: 100,
    sorter: (a, b) => a.email.localeCompare(b.email),
  },
  {
    title: "Name",
    dataIndex: "fullName",
    key: "fullName",
    fixed: "left",
    sorter: (a, b) => a.fullName.localeCompare(b.fullName),
    render: (name) => <Text className="text-nowrap">{name}</Text>,
  },
  {
    title: "Days",
    dataIndex: "days",
    key: "days",
    fixed: "right",
    width: 25,
    render: (active) => <Text>{active}</Text>,
  },
  {
    title: "Att",
    dataIndex: "att",
    key: "att",
    fixed: "right",
    width: 25,
    sorter: (a, b) => a.att - b.att,
    render: (active) => <Text>{active}</Text>,
  },
  {
    title: "Abs",
    dataIndex: "abs",
    key: "abs",
    fixed: "right",
    width: 25,
    sorter: (a, b) => a.abs - b.abs,
    render: (active) => <Text>{active}</Text>,
  },
  {
    title: "Lev",
    dataIndex: "leave",
    key: "leave",
    fixed: "right",
    width: 25,
    sorter: (a, b) => a.leave - b.leave,
    render: (active) => <Text>{active}</Text>,
  },
  {
    title: "Total Classes",
    dataIndex: "average",
    key: "average",
    fixed: "right",
    width: 50,
    render: (active) => <Text>{active}</Text>,
  },
];
const AttendanceSheet = ({
  filterBy,
  courseStudents,
  selectedCourse,
  searchText,
  loading
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [columns, setColumns] = useState([]);
  const [dataSourse, setDataSourse] = useState([]);
  const newColumns = [];
  let att = 0;
  let abs = 0;
  let leave = 0;
  const weekdays = [
    "Saturday",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
  ];

  const handleWeeklyAttendance = async () => {
    const data = courseStudents;
    const attDocs = await getAttendanceFilterBy();
    const weeklyDataSource = [];
    data?.forEach((student) => {
      const newStudent = Object.assign({}, student);
      att = 0;
      abs = 0;
      leave = 0;
      weekdays.forEach((day, index) => {
        let date = new Date(attDocs[0].startOfWeek);
        date.setDate(date.getDate() + index);
        date = date.toISOString().slice(0, 10);
        const attendanceRecord = attDocs.find(
          (record) =>
            record.userId === student.email && record.attendanceDate === date
        );
        if (attendanceRecord) {
          newStudent[day] = { status: attendanceRecord.status, reason: attendanceRecord.reason };
          if (attendanceRecord.status === "absent") {
            abs++;
          } else if (attendanceRecord.status === "present") {
            att++;
          } else {
            leave++;
          }
        } else {
          newStudent[day] = "";
        }
        newStudent.att = att;
        newStudent.abs = abs;
        newStudent.leave = leave;
        newStudent.average = `${Math.round((att / 2) * 100)}%`;
      });
      weeklyDataSource.push(newStudent);
    });
    setDataSourse(weeklyDataSource);

    weekdays.forEach((weekday, i) => {
      const data = {
        title: weekday.substring(0, 3),
        dataIndex: weekday,
        key: weekday,
        width: 50,
        render: (val) => {
          const status = val.status
          const reason = val.reason
          return (status ? (
            <div title={reason} className="d-flex flex-column justify-content-center align-items-center">
              {reason && <AlertCircle className="d-block mx-auto mb-2 text-secondary" />}
              <Tag
                className="m-0"
                color={
                  status === "present"
                    ? "green"
                    : status === "absent"
                      ? "red"
                      : status === "leave"
                        ? "yellow"
                        : ""
                }
              >
                {status?.toUpperCase().substring(0, 1)}
              </Tag>
            </div>
          ) : (
            ""
          ))
        }
      };
      newColumns.push(data);
    });
    setColumns([
      ...initialColumn.slice(0, 3),
      ...newColumns,
      ...initialColumn.slice(-4, -1),
    ]);
    setIsLoading(false)

  };
  const handleMonthlyAttendance = async () => {
    const data = courseStudents;
    let totalClasses = 0;
    const classDays = selectedCourse.days.toUpperCase().split(/[ &]+/);
    const docsMonths =
      await getAttendanceFilterByMonth(
        filterBy === "Current Month" ? "current" : "previous"
      );
    const now = new Date();
    const month = filterBy === "Current Month" ? now.getMonth() : now.getMonth() - 1;
    const year = now.getFullYear();
    const daysInMonth = getDaysInMonth(month, year);
    const monthlyDataSoure = [];

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day + 1);
      const dayName = weekdays[date.getDay()].substring(0, 3).toUpperCase();
      if (classDays.includes(dayName)) {
        totalClasses++;
      }
    }

    data.forEach((student) => {
      const newStudent = Object.assign({}, student);
      att = 0;
      abs = 0;
      leave = 0;
      // loop through each day of the current month
      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day + 1).toISOString().substr(0, 10);
        const attendanceRecord = docsMonths.find(
          (record) =>
            record.userId === student.email && record.attendanceDate === date
        );
        if (attendanceRecord) {
          newStudent[day] = { status: attendanceRecord.status, reason: attendanceRecord.reason };
          // newStudent[day] = attendanceRecord.status;
          if (attendanceRecord.status === "absent") {
            abs++;
          } else if (attendanceRecord.status === "present") {
            att++;
          } else {
            leave++;
          }
        } else {
          newStudent[day] = "";
        }
        newStudent.att = att;
        newStudent.abs = abs;
        newStudent.leave = leave;
        newStudent.average = totalClasses;
      }
      monthlyDataSoure.push(newStudent)
    });
    setDataSourse(monthlyDataSoure);
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day + 1);
      const dayName = weekdays[date.getDay()];
      const suffix = getNumberSuffix(day);
      const data = {
        title: `${day}${suffix} 
        ${new Date(0, month).toLocaleString('en-us', { month: 'short' })} 
        ${dayName.substring(0, 3)}`,
        dataIndex: day,
        key: day,
        width: 50,
        render: (val) => {
          const status = val.status
          const reason = val.reason
          return (status ? (
            <div title={reason} className="d-flex flex-column justify-content-center align-items-center">
              {reason && <AlertCircle className="d-block mx-auto mb-2 text-secondary" />}
              <Tag
                className="m-0"
                color={
                  status === "present"
                    ? "green"
                    : status === "absent"
                      ? "red"
                      : status === "leave"
                        ? "yellow"
                        : ""
                }
              >
                {status?.toUpperCase().substring(0, 1)}
              </Tag>
            </div>
          ) : (
            ""
          ))
        }
      };

      newColumns.push(data);
    }
    setColumns([
      ...initialColumn.slice(0, 3),
      ...newColumns,
      ...initialColumn.slice(4),
    ]);
    setIsLoading(false)
  };
  const handleModuleAttendance = async () => {
    const data = courseStudents;
    let endDate = new Date(selectedCourse.endDate);
    let currentDate = new Date(selectedCourse.startDate);
    const classDays = selectedCourse.days.toUpperCase().split(/[ &]+/);
    let moduleDataSource = [];
    const moduleDates = [];
    const moduleDocs = await getAttendanceFilterByModule(
      selectedCourse.startDate,
      selectedCourse.endDate
    );

    while (currentDate <= endDate) {
      // check if the current date is a Saturday or Sunday
      if (classDays.includes(currentDate.toLocaleString("en-us", { weekday: "short" }).toUpperCase())) {
        const date = new Date(currentDate);
        const dayOfMonth = date.getDate();
        const month = date.toLocaleString("en-us", { month: "long" });
        const suffix = getNumberSuffix(dayOfMonth);
        const title = currentDate.toISOString().substring(0, 10);
        const data = {
          title: `${dayOfMonth}${suffix} ${month.slice(0, 3)} ${currentDate.toLocaleString(
            "en-us",
            { weekday: "short" }
          )}`,
          dataIndex: title,
          key: title,
          width: 100,
          render: (val) => {
            const status = val.status
            const reason = val.reason
            return (status ? (
              <div title={reason} className="d-flex flex-column justify-content-center align-items-center">
                {reason && <AlertCircle className="d-block mx-auto mb-2 text-secondary" />}
                <Tag
                  className="m-0"
                  color={
                    status === "present"
                      ? "green"
                      : status === "absent"
                        ? "red"
                        : status === "leave"
                          ? "yellow"
                          : ""
                  }
                >
                  {status?.toUpperCase().substring(0, 1)}
                </Tag>
              </div>
            ) : (
              ""
            ))
          }
        };

        newColumns.push(data);
        moduleDates.push(title);
      }
      // move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    data.forEach((student) => {
      const newStudent = Object.assign({}, student);
      att = 0;
      abs = 0;
      leave = 0;
      // loop through each day of the current month
      moduleDates.map((v) => {
        const attendanceRecord = moduleDocs.find(
          (record) =>
            record.userId === student.email && record.attendanceDate === v
        );
        if (attendanceRecord) {
          newStudent[v] = { status: attendanceRecord.status, reason: attendanceRecord.reason };
          if (attendanceRecord.status === "absent") {
            abs++;
          } else if (attendanceRecord.status === "present") {
            att++;
          } else {
            leave++;
          }
        } else {
          newStudent[v] = "";
        }
        newStudent.att = att;
        newStudent.abs = abs;
        newStudent.leave = leave;
        newStudent.average = newColumns.length;
      });
      moduleDataSource.push(newStudent)
    });
    setDataSourse(moduleDataSource);
    setColumns([
      ...initialColumn.slice(0, 3),
      ...newColumns,
      ...initialColumn.slice(4),
    ]);
    setIsLoading(false)

  };

  const handleAttendance = async () => {
    setDataSourse([]);
    setIsLoading(true);
    if (filterBy === "Current Week") {
      handleWeeklyAttendance();
    } else if (filterBy === "Current Month" || filterBy === "Previous Month") {
      handleMonthlyAttendance();
    } else if (filterBy === "Current Module") {
      handleModuleAttendance();
    }
  };

  useEffect(() => {
    handleAttendance();
  }, [filterBy]);

  const filteredArray = dataSourse?.filter((student) => {
    const searchQuery = searchText.toLowerCase();
    return (
      student.fullName.toLowerCase().includes(searchQuery) ||
      student.email.toLowerCase().includes(searchQuery) ||
      student.studentId.toString().includes(searchQuery)
    );
  });
  return (
    <div>
      {isLoading ? (
        <center>
          <Spin />
        </center>
      ) :
        <Table
          pagination={false}
          dataSource={filteredArray}
          columns={columns}
          bordered
          loading={isLoading}
          scroll={{ x: "auto" }}
        />
      }
    </div>
  );
};

export default AttendanceSheet;
